export type Solucion = {
  slug: string;
  icon: "globe" | "star" | "message" | "inbox" | "search" | "clock" | "bot";
  number: string;
  title: string;
  shortTitle: string;
  tagline: string;
  description: string;
  bullets: { label: string; text: string }[];
  videoUrl: string | null;
  thumbnailUrl?: string;
  seoTitle: string;
  seoDescription: string;
};

export const soluciones: Solucion[] = [
  {
    slug: "sitio-web",
    icon: "globe",
    number: "01",
    title: "Sitio Web Funcional",
    shortTitle: "Sitio Web",
    tagline: "Tené una web que consigue clientes en cuestión de días.",
    description:
      "Conseguí una web que convierte inmediatamente clientes potenciales en conversaciones que van directo a tu WhatsApp.",
    bullets: [
      {
        label: "Que te encuentren",
        text: "Si un cliente busca tus servicios y no te puede encontrar fácilmente, es probable que se vaya con la competencia. No dejamos que pase eso.",
      },
      {
        label: "Mostrá tus mejores reseñas y trabajos",
        text: "Todos tenemos una o dos malas reseñas. Eso no significa que tus clientes tienen que verlas.",
      },
      {
        label: "Hecha para celular",
        text: "87% de las personas buscan en Google desde su celular. Nos aseguramos que tu negocio se vea súper profesional desde ahí.",
      },
      {
        label: "Optimizada para búsquedas locales",
        text: "Nos aseguramos que tu negocio aparezca cuando alguien busca lo que hacés, en tu zona.",
      },
    ],
    videoUrl: null,
    seoTitle: "Sitio Web Funcional que consigue clientes | CreceLocal",
    seoDescription:
      "Tené una web que convierte visitantes en conversaciones directas a tu WhatsApp. Diseñada para celular y optimizada para búsquedas locales. Lista en días.",
  },
  {
    slug: "embudo-5-estrellas",
    icon: "star",
    number: "02",
    title: "Sistema Automático de Reseñas",
    shortTitle: "Sistema de Reseñas",
    tagline:
      "Pedí feedback después de cada trabajo y conseguí más reseñas de clientes satisfechos.",
    description:
      '"Sí, te dejo una reseña", pero la realidad es que las personas se olvidan. Vamos a recordarle muy amablemente durante algunas semanas.',
    bullets: [
      {
        label: "Pedí feedback después de cada trabajo",
        text: "Un click en tu celular al terminar el trabajo y el sistema le pide la reseña al cliente por vos.",
      },
      {
        label: "Recordatorios automáticos",
        text: "Le recordamos a tus clientes muy amablemente durante algunas semanas para que dejen su reseña.",
      },
      {
        label: "Más reseñas, mejor reputación",
        text: "Cuantas más reseñas tengas, mejor te ven los que te buscan en Google y más te eligen sobre la competencia.",
      },
      {
        label: "Todo automatizado",
        text: "Vos no escribís ni perseguís a nadie. El sistema pide la reseña solo, después de cada trabajo.",
      },
    ],
    videoUrl:
      "https://assets.cdn.filesafe.space/UmeUICnWy44Ung9XrMjl/media/6a20ad302f1efbc07219ab4c.mp4",
    thumbnailUrl:
      "https://vibe.filesafe.space/1775608735188032431/assets/ae0dd920-be7f-4670-8989-96c3c12c98e2.png",
    seoTitle: "Sistema Automático de Reseñas en Google | CreceLocal",
    seoDescription:
      "Pedí feedback después de cada trabajo y conseguí más reseñas de clientes satisfechos en Google. Recordatorios automáticos y solicitud en un click desde tu celular.",
  },
  {
    slug: "campanas-whatsapp",
    icon: "message",
    number: "03",
    title: "Campañas de WhatsApp en un click",
    shortTitle: "Campañas WhatsApp",
    tagline: "Hace que tus clientes vuelvan y te recomienden.",
    description:
      "El cliente más barato es el que ya te compró. El mejor cliente es el que viene referido. Vamos a conseguir más de ambos.",
    bullets: [
      {
        label: "Lo hacemos por vos",
        text: "Enviamos dos campañas para reactivar tu base de contactos. Conseguís resultados la primer semana.",
      },
      {
        label: "Campañas de referidos",
        text: "Tus mejores clientes vienen de referidos. Vamos a recordarles que le cuenten a sus amigos.",
      },
      {
        label: "Campañas de clientes recurrentes",
        text: "Hiciste un service en una casa hoy, y lo tenés que volver a hacer el año que viene. El sistema le avisa automáticamente.",
      },
      {
        label: "Campañas personalizadas en un click",
        text: "Con sólo un click desde tu celular envías una campaña a tu base. No hace falta que contrates un equipo de marketing.",
      },
    ],
    videoUrl:
      "https://assets.cdn.filesafe.space/UmeUICnWy44Ung9XrMjl/media/6a20ad3085f563c78d95b1a9.mp4",
    thumbnailUrl:
      "https://vibe.filesafe.space/1775608735188032431/assets/ca9ec4e2-9f1d-4d89-9224-0d1a355bcd4b.png",
    seoTitle: "Campañas de WhatsApp en un Click | CreceLocal",
    seoDescription:
      "Reactivá tu base de contactos, conseguí referidos y clientes recurrentes con campañas de WhatsApp en un click desde tu celular. Resultados la primer semana.",
  },
  {
    slug: "inbox-unificado",
    icon: "inbox",
    number: "04",
    title: "Inbox Unificado",
    shortTitle: "Inbox Unificado",
    tagline: "Recibí todas las consultas en un mismo lugar.",
    description:
      "WhatsApp, Instagram, Facebook, TikTok y mail. Una conversación por cliente, con historial, sin mensajes traspapelados.",
    bullets: [
      {
        label: "Todos los canales en una bandeja",
        text: "WhatsApp, Instagram, Facebook, TikTok y mail. Una sola bandeja de entrada para todo.",
      },
      {
        label: "Una conversación por cliente",
        text: "Cada contacto tiene su historial completo, sin importar por dónde escribió. Nada se traspapela.",
      },
      {
        label: "Todo el equipo ve lo mismo",
        text: "Nadie contesta dos veces lo mismo ni pierde el hilo de una conversación.",
      },
      {
        label: "Sin mil pestañas abiertas",
        text: "Dejás de saltear entre el teléfono, el Instagram y el mail para ver qué te escribieron.",
      },
    ],
    videoUrl:
      "https://assets.cdn.filesafe.space/UmeUICnWy44Ung9XrMjl/media/6a20ad302f1efbc07219ab4d.mp4",
    thumbnailUrl:
      "https://vibe.filesafe.space/1775608735188032431/assets/98ba7b40-77bc-4f58-ac37-f3c8685bc9ea.png",
    seoTitle: "Inbox Unificado: WhatsApp, Instagram y más | CreceLocal",
    seoDescription:
      "Recibí todas las consultas de WhatsApp, Instagram, Facebook, TikTok y mail en una sola bandeja. Una conversación por cliente, con historial completo.",
  },
  {
    slug: "seo-local",
    icon: "search",
    number: "05",
    title: "SEO Local",
    shortTitle: "SEO Local",
    tagline: "Hace que te encuentren en Google.",
    description:
      "Rankea primero que tus competidores. El SEO lleva tiempo pero vale la pena.",
    bullets: [
      {
        label: "Clientes calificados",
        text: "Dejá de pagar por clientes carísimos con anuncios. Las personas realmente interesadas buscan en Google.",
      },
      {
        label: "Dejá de pagar por clientes no calificados",
        text: "Calidad por sobre cantidad. Estamos de acuerdo.",
      },
      {
        label: "Sistema de captación orgánico",
        text: "Creá tu propio canal de clientes calificados en vez de pagarle a otro por clientes que sólo buscan precio.",
      },
    ],
    videoUrl: null,
    seoTitle: "SEO Local: que te encuentren en Google | CreceLocal",
    seoDescription:
      "Rankea primero que tus competidores en Google. Conseguí clientes calificados con un sistema de captación orgánico, sin pagar por anuncios caros.",
  },
  {
    slug: "seguimiento-automatico",
    icon: "clock",
    number: "06",
    title: "Seguimiento Automático",
    shortTitle: "Seguimiento Automático",
    tagline:
      "Hacele seguimiento a los presupuestos que enviaste de forma automática.",
    description:
      "No perdés ventas por precio. Las perdés por no responder a tiempo y no hacer seguimiento.",
    bullets: [
      {
        label: "El cliente no te dijo que no",
        text: 'Te dijo "lo veo y te aviso". Hace tres semanas. El sistema hace el seguimiento solo.',
      },
      {
        label: "Marcás el presupuesto como enviado",
        text: "Y el sistema hace el seguimiento solo: a los 2, 5, 10 y 20 días. Un botón, eso es todo.",
      },
      {
        label: "Vos no escribís, no te acordás y no perseguís a nadie",
        text: "El sistema trabaja por vos sin que dependa de tu memoria.",
      },
      {
        label: "Reporte todos los lunes",
        text: "Te llega un reporte con la plata que tenés en la calle para que veas dónde estás parado.",
      },
    ],
    videoUrl:
      "https://assets.cdn.filesafe.space/UmeUICnWy44Ung9XrMjl/media/6a20add52f1efbc07219b4b7.mp4",
    thumbnailUrl:
      "https://vibe.filesafe.space/1775608735188032431/assets/f4c0c24f-3e28-4eef-9bcd-e4db87746cb8.png",
    seoTitle: "Seguimiento Automático de Presupuestos | CreceLocal",
    seoDescription:
      "Hacele seguimiento automático a los presupuestos que enviaste. A los 2, 5, 10 y 20 días, sin que dependa de tu memoria. Reporte todos los lunes.",
  },
  {
    slug: "agente-ia",
    icon: "bot",
    number: "07",
    title: "Agente IA",
    shortTitle: "Agente IA",
    tagline:
      "Un agente que responde como vos, a cualquier hora, en todos los canales.",
    description:
      "El agente de IA atiende, califica y agenda. Responde con tu tono y asesora con la info de tu negocio, a cualquier hora, en WhatsApp, Instagram y los demás canales. Cuando el contacto está listo para cerrar, te lo deriva a vos o a tu vendedor.",
    bullets: [
      {
        label: "Responde como vos",
        text: "Se entrena con la información, el tono y el criterio de venta de tu negocio. Funciona siempre igual, a cualquier hora.",
      },
      {
        label: "Atiende, califica y agenda",
        text: "Contesta la consulta, hace las preguntas necesarias para entender si es un cliente real y agenda el trabajo o la llamada.",
      },
      {
        label: "Deja vos el cierre",
        text: "No cierra por vos. Cuando el prospecto está listo, te lo deriva a vos o a tu vendedor. El último paso lo da una persona.",
      },
      {
        label: "Trabaja sobre tu sistema ya armado",
        text: "Se suma sobre el mismo sistema que ya está configurado. No se empieza de cero: usa tu base, tus canales y tus seguimientos.",
      },
    ],
    videoUrl:
      "https://assets.cdn.filesafe.space/UmeUICnWy44Ung9XrMjl/media/6a20ad30ac6660124efd4bc1.mp4",
    thumbnailUrl:
      "https://vibe.filesafe.space/1775608735188032431/assets/b924b0eb-17af-4855-a8e5-19720c837480.png",
    seoTitle: "Agente IA que responde como vos | CreceLocal",
    seoDescription:
      "Un agente de inteligencia artificial que atiende, califica y agenda como lo harías vos, a cualquier hora y en todos tus canales. Te deriva el contacto cuando está listo para cerrar.",
  },
];

export const getSolucion = (slug: string) =>
  soluciones.find((s) => s.slug === slug);
